<ion-modal #qrModalRef [initialBreakpoint]="0.6" [breakpoints]="[0, 0.6]" handleBehavior="cycle">
	<ng-template>
		<ion-content class="text-center ion-padding">
			<p class="text-lg font-semibold">
				{{ productName }}
			</p>
			<div class="flex justify-center w-full mx-auto">
				<qrcode [qrdata]="productId | qrProductCode : { reservation_id: reservationId }" [width]="256"
				        [errorCorrectionLevel]="'M'" [imageHeight]="75" [imageWidth]="75" [margin]="4" [scale]="1"
				        [width]="300">
				</qrcode>
			</div>
			<p class="pb-1 mb-1 font-medium text-center" style="font-size: 1.25rem;">
				<ion-text color="dark">Have guests scan QR code to add themselves to the manifest</ion-text>
			</p>
			<button matRipple class="mt-10 btn-gray" vQbutton="sm" (click)="dismissModal()">Dismiss</button>
		</ion-content>
	</ng-template>
</ion-modal>